import { env } from './env';

const marketing = (path: string): string => new URL(path, env.VITE_MARKETING_URL).toString();

export const LINKS = {
  HOME: marketing('/'),
  TERMS: marketing('/legal/terms/'),
  PRIVACY: marketing('/legal/privacy/'),
  REFUNDS: marketing('/legal/refunds/'),
  QUICKSTART: marketing('/docs/quickstart-claude-code/'),
  SUPPORT_EMAIL: 'info@macswarm.com',
  ENTERPRISE_MAIL: 'mailto:info@macswarm.com?subject=Macswarm%20Enterprise',
} as const;
